<template class="login">
  <div>
    <img
      src="@/assets/logo.png"
      v-motion-slide-visible-once-bottom
      class="pc"
      width="50"
    />
    <h1>Sign in</h1>
    <input v-model="username" placeholder="username" />
    <input v-model="password" type="password" placeholder="Password" />
    <button @click="handleLogin">Continue</button>
    <div v-if="errorMessage" style="color: red">{{ errorMessage }}</div>
    <div class="forgot-password">
      <a href="/password-reset">Forgot Password?</a>
    </div>
  </div>
</template>

<script>
import { login, setAuthToken } from "@/services/api";

export default {
  name: "LoginView",
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await login(this.username, this.password);
        if (response.token) {
          this.errorMessage = "";
          setAuthToken(response.token);
          sessionStorage.setItem("token", response.token);
          localStorage.setItem("userName", this.username);
          localStorage.setItem("userId", response.id);
          localStorage.setItem("isAdmin", response.isAdmin);
          localStorage.setItem("isAttendanceAdmin", response.isAttendanceAdmin);
          localStorage.setItem("hasApprovalRight", response.hasApprovalRight);
          localStorage.setItem("isTopLevel", response.isTopLevel);
          this.$router.push("/dashboard").then(() => {
            window.location.reload();
          });
        } else {
          this.errorMessage = "Login failed.";
        }
      } catch (error) {
        console.error("Login error:", error);
        if (error.response && error.response.status === 429) {
          this.errorMessage =
            "Due to multiple failed attempts in a short period of time, access has been temporarily locked. Please try again in 15 minutes.";
        } else {
          this.errorMessage = "Login failed.";
        }
      }
    },
  },
};
</script>

<style scoped>
.mainView {
  overflow: auto;
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width:calc(100vw - 2rem);
  top: 45%;
  transform: translateY(-45%) !important;
}
h1 {
  color: #0656a2;
  background: linear-gradient(180deg, #0656a2, #3ca0a6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2rem;
}
input {
  padding: 1rem;
  max-width: 300px;
  width: 100%;
  border: 1px solid #d4d4d4;
  border-radius: 10px;
  margin-bottom: 1rem;
}
input::placeholder {
  color: #d4d4d4;
}
button {
  background: var(--grad90);
  color: white;
  border: none;
  padding: 1rem;
  width: 300px;
  border-radius: 10px;
  margin-top: 2rem;
}
.forgot-password {
  margin-top: 1rem;
  opacity: 0.2;
}
.forgot-password a {
  color: #0656a2;
  text-decoration: none;
  font-size: 0.9rem;
}
.forgot-password a:hover {
  text-decoration: underline;
}
</style>
